import { slotProvidersConfiguration } from '../configuration'
import { IFiltersSlots } from '../types/filters'
import { SlotsGameType } from '../types/interfaces/Slots/Slots'

interface ProvidersObject {
  [key: string]: string
}

export const slotsSortArray: (string | number)[] = [
  'Aviamasters',
  // 'evolution:crazytime // temp',
  // 'crazytime:pqe3bikvb6ebirul // sf',
  // 'evolution:monopoly',
  // 'monopoly:pqe4eud2fnorlatr',
  // 'evolution:lightning_roulette',
  // 'roulette:phi5cefi6faxd2gn',
  // 'pragmaticexternal:ChilliHeat',
  // 'evolution:auto_roulette',
  // 'roulette:pizyjnioxtstgml3',
  // 'pragmaticexternal:5LionsMegaways1',
  // 'smartsoft:JetX',
  // 'smartsoft:JetX3',
  // 'smartsoft:Cappadocia',
  // 'evolution:TurkishLightningRoulette',
  // 'pragmaticexternal:SweetBonanza',
  // 'pragmaticexternal:SweetBonanzaXmas',
  // 'pragmaticexternal:StarlightPrincess',
  // 'evolution:super_sicbo',
  // 'sicbo:pizy6cwtjx3tg7wd',
  // 'pragmaticexternal:PowerofThorMegaways',
  // 'evolution:speed_auto_roulette',
  // 'evolution:dream_catcher',
  // 'pragmaticexternal:TheDogHouse',
  // 'evolution:lightningdice',
  // 'evolution:megaball',
  // 'pragmaticexternal:GreatRhinoMegaways',
  // 'pragmaticexternal:5Lions',
  // 'pragmaticexternal:SweetBonanzaCandyland',
  // '1101',
  // 'upgaming_chicken',
  // 'upgaming_dino',
  // 'evolution:GonzosTreasureHunt',
  // 'vs20rhinoluxe_prg',
  // 'upgaming_dice',
  // 'upgaming_keno',
  // 'upgaming_plinko',
  // 'upgaming_hilo',
  // 'bs_7001',
  // 'bs_7000',
  // 'bs_7002',
  // 'bs_7003',
  // '20_burning_hot_html',
  // '5_burning_heart_html',
  // '100_burning_hot_html',
  // '// bs_7004',
  // 'evolution:dealnodeal',
  // 'evolution:dream_catcher',
  // 'moneywheel:pqe3l4gnb6ebjfmv // temp',
  '1301',
  'vs20olympgate',
  'vswaysdogs',
  'vs20fruitsw',
  'vswayslions',
  'aviator',
  'habanero:SGHotHotFruit',
  'vs25chilli',
  'vs20wildparty',
  'vs20lobcrab',
  'vs243nudge4gold',
  'vswayspowzeus',
  'vs20cashmachine',
  'vs20hstgldngt',
  'vs10bbextreme',
  'vs20beefed',
  'vs10fdrasbf',
  'vs20mysteryst',
  'lagranaventura_original',
  'luckyzodiac_original',
  'oktoberfest_original',
  'megashark_original',
  'vampires_original',
  'grandtiger_original',
  'dragonsmystery_original',
  'goldenquest_original',
  'buffalothunderstacks_original',
  'dragonsgift_original',
  'hotchoicedeluxe_original',
  'hot81_original',
  'bookoffruits20_original',
  'bookoffruitshalloween_original',
  'allwayshotfruits_original',
  'vswaysmadame',
  'vswaysbbb',
  'allways_fruits_original',
  'vs25wolfgold',
  'wild_dragon_original',
  'vswaysrhino',
  'billyonaire_original',
  'vswaysbufking',
  'dragons_kingdom_original',
  'wild_shark_original',
  'rouletteroyal_original',
]

export const categoriesSlots = [
  // 'new-year-games',
  // 'Drops & Wins',
  'popular',
  // 'megaways',
  // 'games',
  // 'roulette',
  // 'cardGames',
  // 'lotto',
  // 'fruits',
  // 'hot',
  // 'wild',
  // 'books',
  // 'jokers',
  // 'egypt',
  // 'asia',
  // 'wolfs',
  // 'worldOfSea',
  // 'girls',
  // 'oldSchool',
  // 'luckyClower',
  // 'gangsta',
  // 'sport',
  // 'sweets',
  // 'fantasy',

] // борьба с оптимизацией

export const categoriesSlotsLive = [
  // 'Drops & Wins',
  'popular',
  // 'showGames',
  // 'firstPerson',
  // 'roulette',
  // 'blackJack',
  // 'lotto',
  // 'poker',
  // 'baccarat',
  // 'dice',
]

export const categoriesSlotsFreeSpin = [
  'popular',
  'fruits',
  'oldSchool',
  'wolfs',
  'gangsta',
  'fantasy',
  'wild',
  'books',
  'sport',
  'girls',
  'worldOfSea',
  'asia',
  'megaways',
]

export const providersAuthReq: string[] = Object.entries(slotProvidersConfiguration).reduce(
  (newArray, [provider, config]) => (config.defaultList && !config.multiProvider ? [...newArray, provider] : newArray),
  [] as string[],
)

// const getProvidersNames = () => {
//   let names = {};
//   Object.keys(slotProvidersConfiguration).forEach(t => {
//     names = {
//       ...names,
//       [t]: t,
//     };
//   });
//   return names;
// };

// export const providersNames: ProvidersObject = getProvidersNames();

export const providersSortArray = [
  'favorite',
  'all',
  'pragmaticplay',
  'rubyplay',
  'galaxsys',
  'amatic',
  'upgaming',
  'habanero',
  // 'pragmatic',
  'evoPlay',
  'netent',
  'mga',
  'quickspin',
  'yggdrasil',
  'mascot',
  'microgaming',
  'Tomhorn',
  'vivogaming',
  'igrosoft',
  'betsolutions',
  'KAGaming',
  'greentube',
  'gaminator',
  'wazdan',
  'playtech',
  'apollo',
  'merkur',
  'kajot',
  'playson',
  'booongo',
  'konami',
  'aristocrat',
  'igt',
].map(provider => provider.toLowerCase())

export const liveCasinoProvidersSortArray = [
  'favorite',
  'all',
  'evolution',
  'pragmaticplaylive',
  'xpg',
  'vivogaming',
  'ezugi',
  'luckystreak',
  'atmosfera',
  'alg',
  'imaginelive',
  'tvbet',
].map(provider => provider.toLowerCase())

export const categoriesSortArray = ['megaways', 'games', 'girls', 'tablegames', 'popular', 'roulette', 'gangsta']

export const liveCasinoProviders = [
  'evolution',
  'ezugi',
  'luckystreak',
  'atmosfera',
  'tvbet',
  'atmosphera',
  'pragmaticplaylive',
  'vivogaming',
  'alg',
  'xpg',
  'ImagineLive',
  'TVBet',
].map(provider => provider.toLowerCase())

export const amaticProviders = ['amatic'].map(provider => provider.toLowerCase())

export const starCasinoProviders = [
  'pragmaticplay',
  'amatic',
  'evolution',
  'pragmatic',
  'netent',
  'playson',
  'fishing',
  'cqgaming',
  'microgaming',
  'greentube',
].map(provider => provider.toLowerCase())

export const virtualProviders = ['goldenrace', 'digitain virtual sport', 'universalrace'].map(provider =>
  provider.toLowerCase(),
)

export const excludeProvidersCasino = [
  // исключение казино
  'mancala',
  'evolution',
  'ezugi',
  'luckystreak',
  'atmosfera',
  'tvbet',
  'atmosphera',
  'pragmaticplaylive',
  'alg',
  'vivogaming',
  'xpg',
  'gtech',
  'swintt',
  'Tomhorn',
  'betsoft',
  'augustGaming',
  'blueprint',
  'gamzix',
]
  .map(providerItem => providerItem.toLowerCase())
  .concat(liveCasinoProviders)
  .concat(virtualProviders)

export const newLabelProviders: string[] = ['upgaming', 'pgsoft', 'betsolutions', 'bgaming']

export const additionalProviders = {
  PRAGMATIC: 'pragmatic',
  MASCOT: 'mascot',
  EVOPLAY: 'evoplay',
}

export const slotsAllProviders = {
  OUTCOME: 'outcome',
  ...additionalProviders,
}

export const categoriesByCasinoType = {
  [SlotsGameType.liveCasino]: liveCasinoProviders,
  [SlotsGameType.starCasino]: starCasinoProviders,
  [SlotsGameType.virtual]: virtualProviders,
  [SlotsGameType.amatic]: amaticProviders,
}

export const emptyFilters: IFiltersSlots = {
  setSelectedProviders: () => { },
  selectedProviders: [],
  selectedCategories: [],
  setSelectedCategories: () => { },
  searchString: '',
  setSearchString: () => { },
  selectedSort: '',
  setSelectedSort: () => { },
}
